// TEMA GLOBAL (v2.15.2 · scope corregido en VIS-01R2) — ÚNICA fuente de verdad del modo noche.
// Antes vivía dentro de ConsolaV3 (estado local + efecto que RETIRABA la clase `dark` al
// desmontar), así que Radar, Bitácora, Sitios, menús y modales no heredaban el tema y volvían a
// claro al navegar. Aquí se reutiliza la MISMA clave de persistencia ya existente
// (`galarya_v3_noche`, por navegador/estación): no se crea una segunda preferencia ni se
// sincroniza entre dispositivos o cuentas.
// VIS-01R2 · este provider YA NO escribe la clase `dark` en <html>: lo hace el shell AUTENTICADO
// (components/Layout.js) mientras está montado. Causa raíz de la regresión del Login: la clase
// persistía en rutas públicas y las reglas globales de noche (color de body, h1-h4, variables de
// shadcn) teñían el Login, dejando su texto casi invisible sobre la tarjeta blanca.
import { createContext, useContext, useEffect, useState, useCallback } from "react";

const NOCHE_KEY = "galarya_v3_noche";
const ThemeCtx = createContext({ noche: true, toggleNoche: () => {}, setNoche: () => {} });

export function ThemeProvider({ children }) {
  const [noche, setNoche] = useState(() => {
    try { return localStorage.getItem(NOCHE_KEY) !== "0"; } catch { return true; }
  });
  useEffect(() => {
    try { localStorage.setItem(NOCHE_KEY, noche ? "1" : "0"); } catch { /* almacenamiento bloqueado */ }
  }, [noche]);
  const toggleNoche = useCallback(() => setNoche((v) => !v), []);
  return <ThemeCtx.Provider value={{ noche, toggleNoche, setNoche }}>{children}</ThemeCtx.Provider>;
}

export const useTheme = () => useContext(ThemeCtx);
export { NOCHE_KEY };
